import useHistoryArray from '@/composables/useHistoryArray'

type useHistoryLocationOpts = {
  store?: any
  historyArrayOpts?: any
  useHistoryArray?: any
}

export default function useHistoryLocation(
  opts: useHistoryLocationOpts = {
    store: null,
  }
) {
  const { store } = opts
  const useHistoryArrayLocal = opts.useHistoryArray || useHistoryArray
  // @ts-ignore
  const historyCache = (window._hcl = useHistoryArrayLocal({
    uniqueName: 'location',
    maxItems: 1,
    ...(opts.historyArrayOpts || {}),
  }))
  // @ts-ignore
  const historySelectedCache = (window._hcls = useHistoryArrayLocal({
    uniqueName: 'location_selected',
    maxItems: 1,
  }))
  return {
    /**
     * Persist results to browser cache
     * @warn Issue: native dates store issue
     */
    async persistLocationResultsToHistoryLocation() {
      await historyCache.pushToHistoryArray({
        vehicleResults: store.state.location_module.vehicleResults,
        driverResults: store.state.location_module.driverResults,
        circuitResults: store.state.location_module.circuitResults,
      })
    },
    /**
     * @unused
     * @warn Issue: Unable to parse native dates (broken items)
     */
    async restoreLocationResultsFromHistoryLocation() {
      let obj = await historyCache.getLastFromHistoryArray()
      store.state.location_module.vehicleResults = obj.vehicleResults
      store.state.location_module.driverResults = obj.driverResults
      store.state.location_module.circuitResults = obj.circuitResults
      store.state.search_module.view = 'results' //Switch to results view as default
      store.state.search_module.hasResults = true //Shows a back arrow in selection view
      //@ts-ignore
      console.debugVerbose(6, 'UHL restore', { obj })
    },
    async persistSelectedItem(selectedItem: any = null) {
      let item = {
        ...(selectedItem || store.state.location_module.selectedItem),
      }
      await historySelectedCache.pushToHistoryArray(item)
    },
    /**
     * @unused
     */
    async restoreSelectedItem() {
      let item = await historySelectedCache.getLastFromHistoryArray()
      if (Object.keys(item || {}).length > 0) {
        item.openSubMenu = true
        store.dispatch('location_module/selectItem', item)
      }
    },
    async getSelectedItem() {
      let item = await historySelectedCache.getLastFromHistoryArray()
      return item
    },
  }
}
